<template>
  <div class="not-found text-center bg-light">
    <b-card class="message">
      <h2 class="h1">
        404
      </h2>
      <p class="blockquote">
        The page you're looking does not exist
      </p>
    </b-card>
  </div>
</template>

<script lang="ts" setup>
import { useHead } from '@unhead/vue'

useHead({ title: 'Page Not Found' })

</script>

<style lang="scss" scoped>
.not-found {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;

  .message {
    width: 100%;
    max-width: 1120px;
    padding: 15px;
    margin: auto;
  }
}
</style>
